import { render } from "./InventoryItem.vue?vue&type=template&id=283985c8&scoped=true"
import script from "./InventoryItem.vue?vue&type=script&lang=js"
export * from "./InventoryItem.vue?vue&type=script&lang=js"

import "./InventoryItem.vue?vue&type=style&index=0&id=283985c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283985c8"]])

export default __exports__